import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  list: [],
  total: 0,
  detail: {},
  countries: [],
  error: null,
};

const travelLocationSlice = createSlice({
  name: "travelLocation",
  initialState,
  reducers: {
    // GET LIST
    getTravelLocationListRequest: {
      reducer: (state) => ({
        ...state,
        isLoading: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getTravelLocationListSuccess: {
      reducer: (state, action) => {
        const { docs, totalDocs } = action.payload;
        return {
          ...state,
          isLoading: false,
          list: docs || [],
          total: totalDocs || 0,
          error: null,
        };
      },
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getTravelLocationListFailure: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // GET ALL (No pagination)
    getTravelLocationAllRequest: {
      reducer: (state) => ({
        ...state,
        isLoading: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getTravelLocationAllSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        list: action.payload || [],
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getTravelLocationAllFailure: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // GET COUNTRIES
    getCountriesRequest: {
      reducer: (state) => ({
        ...state,
        error: null,
      }),
      prepare: () => ({ payload: {}, meta: { thunk: true } }),
    },
    getCountriesSuccess: {
      reducer: (state, action) => ({
        ...state,
        countries: action.payload || [],
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getCountriesFailure: {
      reducer: (state, action) => ({
        ...state,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // CREATE
    createTravelLocationRequest: {
      reducer: (state) => ({
        ...state,
        isCreating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    createTravelLocationSuccess: {
      reducer: (state) => ({
        ...state,
        isCreating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    createTravelLocationFailure: {
      reducer: (state, action) => ({
        ...state,
        isCreating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // UPDATE
    updateTravelLocationRequest: {
      reducer: (state) => ({
        ...state,
        isUpdating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateTravelLocationSuccess: {
      reducer: (state) => ({
        ...state,
        isUpdating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    updateTravelLocationFailure: {
      reducer: (state, action) => ({
        ...state,
        isUpdating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // DELETE
    deleteTravelLocationRequest: {
      reducer: (state) => ({
        ...state,
        isDeleting: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    deleteTravelLocationSuccess: {
      reducer: (state) => ({
        ...state,
        isDeleting: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    deleteTravelLocationFailure: {
      reducer: (state, action) => ({
        ...state,
        isDeleting: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },

    // RESTORE
    restoreTravelLocationRequest: {
      reducer: (state) => ({
        ...state,
        isUpdating: true,
        error: null,
      }),
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    restoreTravelLocationSuccess: {
      reducer: (state) => ({
        ...state,
        isUpdating: false,
        error: null,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    restoreTravelLocationFailure: {
      reducer: (state, action) => ({
        ...state,
        isUpdating: false,
        error: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
  },
});

export const {
  getTravelLocationListRequest,
  getTravelLocationListSuccess,
  getTravelLocationListFailure,
  getTravelLocationAllRequest,
  getTravelLocationAllSuccess,
  getTravelLocationAllFailure,
  getCountriesRequest,
  getCountriesSuccess,
  getCountriesFailure,
  createTravelLocationRequest,
  createTravelLocationSuccess,
  createTravelLocationFailure,
  updateTravelLocationRequest,
  updateTravelLocationSuccess,
  updateTravelLocationFailure,
  deleteTravelLocationRequest,
  deleteTravelLocationSuccess,
  deleteTravelLocationFailure,
  restoreTravelLocationRequest,
  restoreTravelLocationSuccess,
  restoreTravelLocationFailure,
} = travelLocationSlice.actions;

export default travelLocationSlice.reducer;